<script setup lang="ts">
import type { EventSideItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<EventSideItemProps>(), { rank: -1 })

const app = useNuxtApp()
const storeIndex = useStoreIndex()

const place = app.$getEventPlace(props.item)
const timeLabel = app.$getEventPeriodLabel(props.item)
</script>

<template>
  <div class="c-eventSideItem">
    <nuxt-link
      v-bind:to="{ path: `/event/${item.article_slug}` }"
    >
      <div class="c-eventSideItem_imageWrap">
        <CommonImage
          v-bind:src="storeIndex.getArticleEyeCatchImageURL(item.eye_catch_image_object)"
          error-src="/images/noimage.svg"
          v-bind:alt="item.title"
          object-fit="cover"
          is-hover-effect
          width="110"
          height="156"
        />
        <div
          v-if="rank !== -1"
          class="c-eventSideItem_chip"
        >
          {{ rank + 1 }}
        </div>
      </div>
    </nuxt-link>
    <div class="c-eventSideItem_data">
      <div
        class="c-eventSideItem_data_eventPlace"
      >
        {{ place }}
      </div>
      <nuxt-link
        class="c-eventSideItem_data_eventName c-clampLines is-clampline2"
        v-bind:to="{ path: `/event/${item.article_slug}` }"
      >
        {{ item.title }}
      </nuxt-link>
      <PeriodRemain
        v-bind:term-from="item.term_from"
        v-bind:term-to="item.term_to"
        v-bind:hide-day-count="item.day_count_display !== 1"
        small
      />
      <div
        class="c-eventSideItem_data_duration"
      >
        {{ timeLabel }}
      </div>
    </div>
  </div>
</template>

<style lang = "scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-eventSideItem {
  display: flex;
  margin-top: 15px;
  margin-bottom: 10px;

  &_imageWrap {
    position: relative;
    width: 110px;
    height: 155px;
  }

  &_chip {
    position: absolute;
    bottom: 0;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #004ea2;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
  }

  &_data {
    flex-grow: 1;
    margin-left: 10px;

    &_eventPlace {
      margin-top: 1px;
      color: var(--color_text_lightgray);
      font-size: 12px;
    }

    &_eventName {
      margin-top: 5px;
      margin-bottom: 8px;
      color: var(--color_text_base);
      font-size: 14px;
      font-weight: bold;
    }

    &_duration {
      margin-top: 5px;
      color: #252525;
      font-size: 12px;
    }
  }
}
</style>
